import { blue, green, grey, lightBlue, neutralGrey, neutralWhite, orange, red , aquanowGreen , aquanowSlate  } from '../../colors';


const palette = {
  primary: {
    main: "#4EC6A1",
    light: aquanowGreen[500],
    dark: "#4EC6A1",
    darker: "#4EC6A1",
    contrastText: aquanowGreen[250],
  },
  common: {
    black: neutralGrey[975],
    white: neutralGrey[25],
  },
  secondary: {
    main: neutralGrey[700],
    light: neutralGrey[750],
    dark: neutralGrey[650],
    darker: neutralGrey[600],
    contrastText: neutralGrey[25],
  },
  error: {
    main: red[500],
    light: red[800],
    dark: red[400],
    darker: red[300],
    contrastText: neutralGrey[975],
  },
  success: {
    main: green[500],
    light: green[800],
    dark: green[400],
    darker: green[300],
    contrastText: neutralGrey[975],
  },
  warning: {
    main: '#f9a43a',
    light: '#f87171',
    dark: '#e65100',
    darker: '#e65100',
    contrastText: neutralGrey[975],
  },
  navbar: {
    main: "#FFFFFF",
    light: "#111827",
    dark: "#000000",
    contrastText: "#FFFFFF",
  },
  info: {
    main: blue[500],
    light: blue[800],
    dark: blue[400],
    darker: blue[300],
    contrastText: neutralGrey[975],
  },
  grey: {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  text: {
    primary: "#2A2D35",
    secondary: neutralGrey[800],
    disabled: neutralGrey[650],
  },
  divider: "#E4E7EB",
  background: {
    paper: "#FFFFFF",
    default: "#fafafa",
  },
  action: {
    active: aquanowGreen[250],
    hover: 'rgba(255, 255, 255, 0.0800)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.1600)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3000)',
    disabledBackground: neutralGrey[800],
    disabledOpacity: 0.38,
    focusBorderInner: neutralGrey[975],
    focusBorderOuter: blue[400],
    focusOpacity: 0.16,
    activatedOpacity: 0.24,
  },
};

export default palette;

